import { doc, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "../firebase";

export function normalizeBrazilianPhone(value) {
  let digits = String(value || "").replace(/\D/g, "");
  if (digits.startsWith("55") && digits.length > 11) digits = digits.slice(2);
  digits = digits.slice(0, 11);

  if (digits.length < 10 || digits.length > 11) {
    return { valid: false, national: digits, e164: "" };
  }

  return { valid: true, national: digits, e164: `+55${digits}` };
}

export async function persistPassengerPhone({ userId, rawPhone, database = db }) {
  if (!userId) {
    const error = new Error("Usuário não autenticado.");
    error.code = "auth/user-not-authenticated";
    throw error;
  }

  const normalized = normalizeBrazilianPhone(rawPhone);
  if (!normalized.valid) {
    const error = new Error("Telefone inválido.");
    error.code = "profile/invalid-phone";
    throw error;
  }

  // setDoc + merge also covers Google users whose profile document does not
  // exist yet; updateDoc previously failed in exactly that situation.
  await setDoc(doc(database, "users", userId), {
    telefone: normalized.national,
    atualizadoEm: serverTimestamp(),
  }, { merge: true });

  return normalized;
}

export async function persistPhoneAndResumeRide({
  userId,
  rawPhone,
  pendingPayment,
  onPhoneSaved,
  resumeRide,
  database = db,
}) {
  const saved = await persistPassengerPhone({ userId, rawPhone, database });
  await onPhoneSaved?.(saved);
  if (pendingPayment && resumeRide) await resumeRide(pendingPayment);
  return { saved, resumed: !!(pendingPayment && resumeRide) };
}
